import z from 'zod'

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export const personModel = z.object({
  __typename: z.literal('Person').default('Person'),
  id: z.string(),
  isForeign: z.boolean(),
  name: z.string(),
  email: z.string().email(),
  documentNumber: z.string().nullable(),
  genre: z.nativeEnum(Gender),
  birthDate: z.string().datetime().nullable(),
  birthMonth: z.number().positive().nullable(),
  birthYear: z.number().positive().nullable(),
})

export type PersonModel = z.infer<typeof personModel>
